import apiService from "../../ApiService";

export const celcomSubscribe = () => {
  return apiService.post<unknown>({
    path: `v1/store/celcom/subscribe`,
  });
};
